export default {"src":"/_next/static/media/Pediatric Disorder.16574640.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};